// extracted by mini-css-extract-plugin
export default {"Container":"PricingPills_Container__wGoYN","Label":"PricingPills_Label__XEzG6","IconContainer":"PricingPills_IconContainer__IFFjT"};